 jQuery(document).ready(function($){
    //jQuery('#exampleModalToggle').modal('show');
   // Check if the URL contains the specified string
    if (window.location.href.indexOf('?from=fructosecontrol') !== -1) {
        // Show the modal if the string is found
        $('#exampleModalToggle').modal('show');
    }
   jQuery('li.has_sub_menu > .sub_menu_icon').on('click', function(e){
		e.preventDefault();
		jQuery(this).toggleClass('active');
		jQuery(this).parent().find('ul.sub_menu').slideToggle('');
	});
   // jQuery('.reviewbtn .revbtn').click(function(event){
   //    event.preventDefault(); // Prevent the default action
   //    jQuery('.reviewinner p').toggleClass('expand');
   //  });
   // measure Length
   
   jQuery('.reviewbtn .revbtn').click(function(event) {
     event.preventDefault(); // Prevent the default action
     // Find the closest parent element and then find the corresponding .reviewinner
     var reviewInner = jQuery(this).closest('.reviewbtn').siblings('.reviewinner p');
    
    // Toggle the 'expand' class
    reviewInner.toggleClass('expand');
     // Check if the 'expand' class is present and change the button text accordingly
    if (reviewInner.hasClass('expand')) {
        jQuery(this).text('Read Less >'); // Change text to 'Read Less'
    } else {
        jQuery(this).text('Read More >'); // Change text to 'Read More'
    }
   });
	jQuery('ul.sub_menu li > .sub_menu_icon').on('click', function(e){
		e.preventDefault();
		jQuery(this).toggleClass('active');
		jQuery(this).parent().find('ul.list_product_category li:not(:first-child)').slideToggle('');
	});
	jQuery('.selected_product_on_mobile').on('click', function(e){
		e.preventDefault();
		jQuery(this).toggleClass('active');
		jQuery(this).find('.sub_menu_icon').toggleClass('active');
		jQuery(this).next().slideToggle('');
	});
   jQuery('ul.nav_menu li.has_sub_menu').each( function(){
		jQuery(this).append('<span class="sub_menu_icon"></span>');
	});
	jQuery('ul.nav_menu li.has_sub_menu.mega_menu ul.sub_menu > li').each( function(){
		jQuery(this).append('<span class="sub_menu_icon"></span>');
	});
   jQuery('li.has_sub_menu > .sub_menu_icon').on('click', function(e){
		e.preventDefault();
		jQuery(this).toggleClass('active');
		jQuery(this).parent().find('ul.sub_menu').slideToggle('');
	});
  
	jQuery('ul.sub_menu li > .sub_menu_icon').on('click', function(e){
		e.preventDefault();
		jQuery(this).toggleClass('active');
		jQuery(this).parent().find('ul.list_product_category li:not(:first-child)').slideToggle('');
	});
	jQuery('.selected_product_on_mobile').on('click', function(e){
		e.preventDefault();
		jQuery(this).toggleClass('active');
		jQuery(this).find('.sub_menu_icon').toggleClass('active');
		jQuery(this).next().slideToggle('');
	});

   // Shared glossary eligibility rules. Keep one meaningful glossary term per
   // content block, and never decorate navigation or other interactive UI.
   window.LIV3Glossary = window.LIV3Glossary || (function () {
      const usedBlocks = new WeakSet();
      const excludedSelector = [
         'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
         'a', 'button', 'nav', 'header', 'footer', 'aside',
         'figcaption', 'cite', 'sup',
         '.guidleft', '.hovertext', '.highlighthov',
         '.breadcrumbs', '.pagination', '.referlist', '.reference-list',
         '.references', '.footnotelist', '[data-glossary-ignore]'
      ].join(',');

      function canDecorate(node) {
         const parent = node && node.parentElement;
         if (!parent || !parent.closest('main') || parent.closest(excludedSelector)) {
            return false;
         }

         const contentBlock = parent.closest('p, li, td, dd, blockquote') || parent;
         if (usedBlocks.has(contentBlock)) {
            return false;
         }

         usedBlocks.add(contentBlock);
         return true;
      }

      return { canDecorate: canDecorate };
   }());

   // Craving
//    function wrapCravingsText(node) {
//         $(node).contents().each(function () {
//             if (this.nodeType === 3 && /\bCravings\b/i.test(this.nodeValue)) {
//                 const updatedText = this.nodeValue.replace(
//                     /\b(Cravings)\b/gi,
//                     '<span class="highlighthov">$1 <div class="hovertext">Cravings are strong urges to eat certain foods, usually high in sugar, salt, or fat. While often linked to emotions or willpower, research shows they’re more about the body’s energy needs. Your body may crave food not out of desire, but because it’s low on energy and struggling to access it. <a href="https://liv3health.com/pages/cravings">Read More</a>  </div></span>'
//                 );
//                 $(this).replaceWith(updatedText);
//             } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//                 wrapCravingsText(this); // Recurse into children
//             }
//         });
//     }

//     wrapCravingsText(document.body);

function wrapCravingsText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;

    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }

    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bCravings\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Cravings)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Cravings are strong urges to eat certain foods, usually high in sugar, salt, or fat. While often linked to emotions or willpower, research shows they’re more about the body’s energy needs. Your body may crave food not out of desire, but because it’s low on energy and struggling to access it. <a href="https://liv3health.com/pages/cravings">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    // Replace subsequent occurrences with just the plain word (no tooltip or link)
                    const newText = this.nodeValue.replace(/\b(Cravings)\b/gi, '$1');
                    $(this).replaceWith(newText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}

if (!window.location.href.toLowerCase().includes('cravings')) {
    wrapCravingsText(document.body);
}



   // Aldolase B
//    function wrapaldolaseText(node) {
//         $(node).contents().each(function () {
//             if (this.nodeType === 3 && /\Aldolase\b/i.test(this.nodeValue)) {
//                 const updatedText = this.nodeValue.replace(
//                     /\b(Aldolase)\b/gi,
//                     '<span class="highlighthov">$1 <div class="hovertext">Aldolase B is a liver-specific enzyme involved in the second step of fructose metabolism. It breaks down fructose-1-phosphate (produced by fructokinase) into glyceraldehyde and dihydroxyacetone phosphate. <a href="https://liv3health.com/pages/aldolase-b">Read More</a>  </div></span>'
//                 );
//                 $(this).replaceWith(updatedText);
//             } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//                 wrapaldolaseText(this); // Recurse into children
//             }
//         });
//     }
//     wrapaldolaseText(document.body);
function wrapaldolaseText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;

    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }

    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bAldolase\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const updatedText = this.nodeValue.replace(
                        /\b(Aldolase)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Aldolase B is a liver-specific enzyme involved in the second step of fructose metabolism. It breaks down fructose-1-phosphate (produced by fructokinase) into glyceraldehyde and dihydroxyacetone phosphate. <a href="https://liv3health.com/pages/aldolase-b">Read More</a></div></span>`
                    );
                    $(this).replaceWith(updatedText);
                    tooltipCount++;
                } else {
                    // Replace subsequent occurrences with just the plain word (no tooltip or link)
                    const newText = this.nodeValue.replace(/\b(Aldolase)\b/gi, '$1');
                    $(this).replaceWith(newText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}

if (!window.location.href.toLowerCase().includes('aldolase-b')) {
    wrapaldolaseText(document.body);
}


   // AMPK
//    function wrapAMPKText(node) {
//         $(node).contents().each(function () {
//             if (this.nodeType === 3 && /\AMPK\b/i.test(this.nodeValue)) {
//                 const updatedText = this.nodeValue.replace(
//                     /\b(AMPK)\b/gi,
//                     '<span class="highlighthov">$1 <div class="hovertext">AMPK (AMP-activated protein kinase) is an enzyme that acts as an energy sensor in your cells. When energy is low, AMPK turns on systems that generate ATP and repair damage—like a cellular reboot switch. <a href="https://liv3health.com/pages/ampk">Read More</a>  </div></span>'
//                 );
//                 $(this).replaceWith(updatedText);
//             } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//                 wrapAMPKText(this); // Recurse into children
//             }
//         });
//     }
//     wrapAMPKText(document.body);
function wrapAMPKText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;

    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }

    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bAMPK\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const updatedText = this.nodeValue.replace(
                        /\b(AMPK)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">AMPK (AMP-activated protein kinase) is an enzyme that acts as an energy sensor in your cells. When energy is low, AMPK turns on systems that generate ATP and repair damage—like a cellular reboot switch. <a href="https://liv3health.com/pages/ampk">Read More</a></div></span>`
                    );
                    $(this).replaceWith(updatedText);
                    tooltipCount++;
                } else {
                    // Replace subsequent occurrences with just the plain word (no tooltip or link)
                    const newText = this.nodeValue.replace(/\b(AMPK)\b/gi, '$1');
                    $(this).replaceWith(newText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}

if (!window.location.href.toLowerCase().includes('ampk')) {
    wrapAMPKText(document.body);
}

   // Berberine
//    function wrapberberineText(node) {
//         $(node).contents().each(function () {
//             if (this.nodeType === 3 && /\Berberine\b/i.test(this.nodeValue)) {
//                 const updatedText = this.nodeValue.replace(
//                     /\b(Berberine)\b/gi,
//                     '<span class="highlighthov">$1 <div class="hovertext">Berberine is a bioactive compound extracted from several plants, including barberry and goldenseal. It has a long history in traditional medicine and has been widely studied for its metabolic benefits. <a href="https://liv3health.com/pages/berberine">Read More</a>  </div></span>'
//                 );
//                 $(this).replaceWith(updatedText);
//             } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//                 wrapberberineText(this); // Recurse into children
//             }
//         });
//     }
//     wrapberberineText(document.body);
function wrapberberineText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;

    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }

    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bBerberine\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const updatedText = this.nodeValue.replace(
                        /\b(Berberine)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Berberine is a bioactive compound extracted from several plants, including barberry and goldenseal. It has a long history in traditional medicine and has been widely studied for its metabolic benefits. <a href="https://liv3health.com/pages/berberine">Read More</a></div></span>`
                    );
                    $(this).replaceWith(updatedText);
                    tooltipCount++;
                } else {
                    // Replace subsequent occurrences with just the plain word (no tooltip or link)
                    const newText = this.nodeValue.replace(/\b(Berberine)\b/gi, '$1');
                    $(this).replaceWith(newText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}

if (!window.location.href.toLowerCase().includes('berberine')) {
    wrapberberineText(document.body);
}

   // Bloating
//    function wrapbloatingText(node) {
//         $(node).contents().each(function () {
//             if (this.nodeType === 3 && /\Bloating\b/i.test(this.nodeValue)) {
//                 const updatedText = this.nodeValue.replace(
//                     /\b(Bloating)\b/gi,
//                     '<span class="highlighthov">$1 <div class="hovertext">Bloating is a sensation of abdominal pressure, fullness, or visible distension. It can be caused by digestion, gas, inflammation, or fluid retention. <a href="https://liv3health.com/pages/bloating-glossary">Read More</a>  </div></span>'
//                 );
//                 $(this).replaceWith(updatedText);
//             } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//                 wrapbloatingText(this); // Recurse into children
//             }
//         });
//     }
//     wrapbloatingText(document.body);
function wrapbloatingText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;

    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }

    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bBloating\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const updatedText = this.nodeValue.replace(
                        /\b(Bloating)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Bloating is a sensation of abdominal pressure, fullness, or visible distension. It can be caused by digestion, gas, inflammation, or fluid retention. <a href="https://liv3health.com/pages/bloating-glossary">Read More</a></div></span>`
                    );
                    $(this).replaceWith(updatedText);
                    tooltipCount++;
                } else {
                    // Replace subsequent occurrences with just the plain word (no tooltip or link)
                    const newText = this.nodeValue.replace(/\b(Bloating)\b/gi, '$1');
                    $(this).replaceWith(newText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}

if (!window.location.href.toLowerCase().includes('bloating-glossary')) {
    wrapbloatingText(document.body);
}

   // Brain Fog
//    function wrapbrainText(node) {
//         $(node).contents().each(function () {
//             if (this.nodeType === 3 && /\Brain Fog\b/i.test(this.nodeValue)) {
//                 const updatedText = this.nodeValue.replace(
//                     /\b(Brain Fog)\b/gi,
//                     '<span class="highlighthov">$1 <div class="hovertext">Brain fog describes a state of mental sluggishness, forgetfulness, and lack of focus. It is not a clinical diagnosis but is increasingly recognized as a symptom of metabolic stress. <a href="https://liv3health.com/pages/brain-fog">Read More</a>  </div></span>'
//                 );
//                 $(this).replaceWith(updatedText);
//             } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//                 wrapbrainText(this); // Recurse into children
//             }
//         });
//     }
//     wrapbrainText(document.body);
function wrapbrainText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;

    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }

    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bBrain Fog\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const updatedText = this.nodeValue.replace(
                        /\b(Brain Fog)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Brain fog describes a state of mental sluggishness, forgetfulness, and lack of focus. It is not a clinical diagnosis but is increasingly recognized as a symptom of metabolic stress. <a href="https://liv3health.com/pages/brain-fog">Read More</a></div></span>`
                    );
                    $(this).replaceWith(updatedText);
                    tooltipCount++;
                } else {
                    // Replace subsequent occurrences with just the plain phrase (no tooltip or link)
                    const newText = this.nodeValue.replace(/\b(Brain Fog)\b/gi, '$1');
                    $(this).replaceWith(newText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}

if (!window.location.href.toLowerCase().includes('brain-fog')) {
    wrapbrainText(document.body);
}

   // Carbohydrate Intolerance
//    function wrapCarbohydrateText(node) {
//         $(node).contents().each(function () {
//             if (this.nodeType === 3 && /\Carbohydrate Intolerance\b/i.test(this.nodeValue)) {
//                 const updatedText = this.nodeValue.replace(
//                     /\b(Carbohydrate Intolerance)\b/gi,
//                     '<span class="highlighthov">$1 <div class="hovertext">Carbohydrate intolerance refers to an inability to metabolize carbs efficiently without experiencing adverse effects like blood sugar swings, weight gain, or energy crashes. <a href="https://liv3health.com/pages/carbohydrate-intolerance">Read More</a>  </div></span>'
//                 );
//                 $(this).replaceWith(updatedText);
//             } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//                 wrapCarbohydrateText(this); // Recurse into children
//             }
//         });
//     }
//     wrapCarbohydrateText(document.body);
function wrapCarbohydrateText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;

    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }

    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bCarbohydrate Intolerance\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const updatedText = this.nodeValue.replace(
                        /\b(Carbohydrate Intolerance)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Carbohydrate intolerance refers to an inability to metabolize carbs efficiently without experiencing adverse effects like blood sugar swings, weight gain, or energy crashes. <a href="https://liv3health.com/pages/carbohydrate-intolerance">Read More</a></div></span>`
                    );
                    $(this).replaceWith(updatedText);
                    tooltipCount++;
                } else {
                    // Replace subsequent occurrences with just the plain phrase (no tooltip or link)
                    const newText = this.nodeValue.replace(/\b(Carbohydrate Intolerance)\b/gi, '$1');
                    $(this).replaceWith(newText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}

if (!window.location.href.toLowerCase().includes('carbohydrate-intolerance')) {
    wrapCarbohydrateText(document.body);
}

   // De Novo Lipogenesis
//    function wrapdonovoText(node) {
//         $(node).contents().each(function () {
//             if (this.nodeType === 3 && /\De Novo Lipogenesis\b/i.test(this.nodeValue)) {
//                 const updatedText = this.nodeValue.replace(
//                     /\b(De Novo Lipogenesis)\b/gi,
//                     '<span class="highlighthov">$1 <div class="hovertext">De novo lipogenesis (DNL) is the process where the body turns excess carbs—mainly sugars—into fat. “De novo” means “from the beginning,” referring to making fat from non-fat sources. This mostly happens in the liver but can also occur in fat tissue and other organs when needed. <a href="https://liv3health.com/pages/de-novo-lipogenesis">Read More</a>  </div></span>'
//                 );
//                 $(this).replaceWith(updatedText);
//             } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//                 wrapdonovoText(this); // Recurse into children
//             }
//         });
//     }
//     wrapdonovoText(document.body);
function wrapdonovoText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;

    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }

    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bDe Novo Lipogenesis\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const updatedText = this.nodeValue.replace(
                        /\b(De Novo Lipogenesis)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">De novo lipogenesis (DNL) is the process where the body turns excess carbs—mainly sugars—into fat. “De novo” means “from the beginning,” referring to making fat from non-fat sources. This mostly happens in the liver but can also occur in fat tissue and other organs when needed. <a href="https://liv3health.com/pages/de-novo-lipogenesis">Read More</a></div></span>`
                    );
                    $(this).replaceWith(updatedText);
                    tooltipCount++;
                } else {
                    const newText = this.nodeValue.replace(/\b(De Novo Lipogenesis)\b/gi, '$1');
                    $(this).replaceWith(newText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}

if (!window.location.href.toLowerCase().includes('de-novo-lipogenesis')) {
    wrapdonovoText(document.body);
}

   // Dopamine
//    function wrapDopamineText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bDopamine\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Dopamine)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Dopamine is a key neurotransmitter in the brain's reward and motivation systems. It helps reinforce behaviors that bring pleasure or promote survival. <a href="https://liv3health.com/pages/dopamine">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapDopamineText(this); // Recurse into children
//         }
//     });
// }
// wrapDopamineText(document.body);
function wrapDopamineText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bDopamine\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Dopamine)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Dopamine is a key neurotransmitter in the brain's reward and motivation systems. It helps reinforce behaviors that bring pleasure or promote survival. <a href="https://liv3health.com/pages/dopamine">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Dopamine)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('dopamine')) {
wrapDopamineText(document.body);
}
// Endogenous Fructose
//    function wrapEndogenousText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bEndogenous\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Endogenous)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Endogenous fructose is the fructose your body makes on its own, not from food. While most people link fructose to sugar or corn syrup, the body can convert glucose and other sugars into fructose through the polyol pathway. This process occurs inside cells and is often triggered by stress, dehydration, or too much salt, refined carbs, or alcohol. <a href="https://liv3health.com/pages/endogenous-fructose">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapEndogenousText(this); // Recurse into children
//         }
//     });
// }
// wrapEndogenousText(document.body);
function wrapEndogenousText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bEndogenous\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Endogenous)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Endogenous fructose is the fructose your body makes on its own, not from food. While most people link fructose to sugar or corn syrup, the body can convert glucose and other sugars into fructose through the polyol pathway. This process occurs inside cells and is often triggered by stress, dehydration, or too much salt, refined carbs, or alcohol. <a href="https://liv3health.com/pages/endogenous-fructose">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Endogenous)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('endogenous-fructose')) {
wrapEndogenousText(document.body);
}
// Fructose
function wrapfructoseText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\Fructose\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Fructose)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Fructose is a sugar found naturally in fruits, fruit juices, some vegetables and honey. Table sugar, called sucrose, also has fructose. High-fructose corn syrup is a sweetener that is in many processed foods and drinks. <a href="https://liv3health.com/pages/fructose">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Fructose)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}
if (!window.location.pathname.toLowerCase().replace(/\/$/, '').endsWith('/pages/fructose')) {
wrapfructoseText(document.body);
}
   // Fasting
//    function wrapFastingText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bFasting\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Fasting)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Fasting is the voluntary abstention from food for a period of time. It triggers metabolic adaptations that improve energy efficiency, fat burning, and cellular repair. <a href="https://liv3health.com/pages/fasting">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapFastingText(this); // Recurse into children
//         }
//     });
// }
// wrapFastingText(document.body);
function wrapFastingText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bFasting\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Fasting)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Fasting is the voluntary abstention from food for a period of time. It triggers metabolic adaptations that improve energy efficiency, fat burning, and cellular repair. <a href="https://liv3health.com/pages/fasting">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Fasting)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('fasting')) {
wrapFastingText(document.body);
}
   // Fatty Liver
//    function wrapFattyText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bFatty Liver\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Fatty Liver)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Fatty liver is a buildup of fat in liver cells, often without symptoms at first. Over time, it can progress to inflammation (NASH), fibrosis, cirrhosis, and liver failure. <a href="https://liv3health.com/pages/fatty-liver">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapFattyText(this); // Recurse into children
//         }
//     });
// }
// wrapFattyText(document.body);
function wrapFattyText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;

    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }

    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bFatty Liver\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Fatty Liver)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Fatty liver is a buildup of fat in liver cells, often without symptoms at first. Over time, it can progress to inflammation (NASH), fibrosis, cirrhosis, and liver failure. <a href="https://liv3health.com/pages/fatty-liver">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Fatty Liver)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}

if (!window.location.href.toLowerCase().includes('fatty-liver')) {
    wrapFattyText(document.body);
}

   // Fructokinase
//    function wrapFructokinaseText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bFructokinase\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Fructokinase)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Fructokinase—also known as ketohexokinase (KHK)—is the enzyme that kickstarts the metabolism of fructose. Unlike glucose, which is metabolized through tightly regulated pathways, fructose is rapidly processed by fructokinase in the liver, converting it into fructose-1-phosphate using ATP. This bypasses key metabolic checkpoints, allowing fructose to flood the liver with very little resistance. <a href="https://liv3health.com/pages/fructokinase">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapFructokinaseText(this); // Recurse into children
//         }
//     });
// }
// wrapFructokinaseText(document.body);
function wrapFructokinaseText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;

    // Helper function to check if a node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }

    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bFructokinase\b/i.test(this.nodeValue)) {
                // Only add tooltip if not inside heading and tooltipCount < maxTooltips
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Fructokinase)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Fructokinase—also known as ketohexokinase (KHK)—is the enzyme that kickstarts the metabolism of fructose. Unlike glucose, which is metabolized through tightly regulated pathways, fructose is rapidly processed by fructokinase in the liver, converting it into fructose-1-phosphate using ATP. This bypasses key metabolic checkpoints, allowing fructose to flood the liver with very little resistance. <a href="https://liv3health.com/pages/fructokinase">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    // Replace with plain text (no tooltip)
                    const plainText = this.nodeValue.replace(/\b(Fructokinase)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}

if (!window.location.href.toLowerCase().includes('fructokinase')) {
    wrapFructokinaseText(document.body);
}

   // Glucose
//    function wrapGlucoseText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bGlucose\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Glucose)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Glucose is a monosaccharide and the body's preferred fuel source. It circulates in the blood and is taken up by cells in response to the hormone insulin. <a href="https://liv3health.com/pages/glucose">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapGlucoseText(this); // Recurse into children
//         }
//     });
// }
// wrapGlucoseText(document.body);
function wrapGlucoseText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bGlucose\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Glucose)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Glucose is a monosaccharide and the body's preferred fuel source. It circulates in the blood and is taken up by cells in response to the hormone insulin. <a href="https://liv3health.com/pages/glucose">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Glucose)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('glucose')) {
wrapGlucoseText(document.body);
}
   // Gout
//    function wrapGoutText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bGout\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Gout)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Gout is a type of inflammatory arthritis caused by crystalized uric acid in the joints—usually the big toe. It causes swelling, pain, and limited mobility. <a href="https://liv3health.com/pages/gout-glossary">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapGoutText(this); // Recurse into children
//         }
//     });
// }
// wrapGoutText(document.body);
function wrapGoutText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bGout\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Gout)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Gout is a type of inflammatory arthritis caused by crystalized uric acid in the joints—usually the big toe. It causes swelling, pain, and limited mobility. <a href="https://liv3health.com/pages/gout-glossary">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Gout)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('gout-glossary')) {
wrapGoutText(document.body);
}
   // High-Fructose Corn Syrup (HFCS)
//    function wrapHFCSText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bHigh-Fructose Corn Syrup\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(High-Fructose Corn Syrup)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">High-fructose corn syrup (HFCS) is a liquid sweetener made from corn starch. It's commonly used in processed foods and soft drinks because it's cheap, stable, and sweeter than sugar. <a href="https://liv3health.com/pages/high-fructose-corn-syrup-hfcs">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapHFCSText(this); // Recurse into children
//         }
//     });
// }
// wrapHFCSText(document.body);
function wrapHFCSText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bHigh-Fructose Corn Syrup\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(High-Fructose Corn Syrup)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">High-fructose corn syrup (HFCS) is a liquid sweetener made from corn starch. It's commonly used in processed foods and soft drinks because it's cheap, stable, and sweeter than sugar. <a href="https://liv3health.com/pages/high-fructose-corn-syrup-hfcs">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(High-Fructose Corn Syrup)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('high-fructose-corn-syrup-hfcs')) {
wrapHFCSText(document.body);
}
   // Insulin Resistance
//    function wrapInsulinText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bInsulin Resistance\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Insulin Resistance)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Insulin resistance is a metabolic condition where the body’s cells—especially in the liver, muscles, and fat—stop responding properly to insulin. This hormone helps move glucose from the blood into cells for energy. When cells resist insulin, blood sugar rises, prompting the pancreas to produce more insulin, leading to broader metabolic issues. <a href="https://liv3health.com/pages/insulin-resistance-1">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapInsulinText(this); // Recurse into children
//         }
//     });
// }
// wrapInsulinText(document.body);
function wrapInsulinText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bInsulin Resistance\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Insulin Resistance)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Insulin resistance is a metabolic condition where the body’s cells—especially in the liver, muscles, and fat—stop responding properly to insulin. This hormone helps move glucose from the blood into cells for energy. When cells resist insulin, blood sugar rises, prompting the pancreas to produce more insulin, leading to broader metabolic issues. <a href="https://liv3health.com/pages/insulin-resistance-1">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Insulin Resistance)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('insulin-resistance-1')) {
wrapInsulinText(document.body);
}
   // Ketosis
//    function wrapKetosisText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bKetosis\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Ketosis)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Ketosis is a metabolic state where the body burns fat for fuel instead of carbohydrates. It produces molecules called ketones that provide energy to the brain and muscles—common in low-carb or fasting regimens. <a href="https://liv3health.com/pages/ketosis">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapKetosisText(this); // Recurse into children
//         }
//     });
// }
// wrapKetosisText(document.body);
function wrapKetosisText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bKetosis\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Ketosis)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Ketosis is a metabolic state where the body burns fat for fuel instead of carbohydrates. It produces molecules called ketones that provide energy to the brain and muscles—common in low-carb or fasting regimens. <a href="https://liv3health.com/pages/ketosis">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Ketosis)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('ketosis')) {
wrapKetosisText(document.body);
}
   // Leptin Resistance
//    function wrapLeptinText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bLeptin Resistance\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Leptin Resistance)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Leptin is a hormone produced by fat cells that signals the brain when you've had enough to eat. It helps regulate appetite and energy expenditure. <a href="https://liv3health.com/pages/leptin-resistance">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapLeptinText(this); // Recurse into children
//         }
//     });
// }
// wrapLeptinText(document.body);
function wrapLeptinText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bLeptin Resistance\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Leptin Resistance)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Leptin is a hormone produced by fat cells that signals the brain when you've had enough to eat. It helps regulate appetite and energy expenditure. <a href="https://liv3health.com/pages/leptin-resistance">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Leptin Resistance)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('leptin-resistance')) {
wrapLeptinText(document.body);
}
   // Luteolin
//    function wrapLuteolinText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bLuteolin\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Luteolin)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Luteolin is a naturally occurring flavonoid found in a variety of plant-based foods, including celery, parsley, chamomile tea, thyme, artichokes, and green peppers. As a member of the polyphenol family, luteolin has long been studied for its potent antioxidant, anti-inflammatory, and neuroprotective properties. But recent research is uncovering an even more intriguing role—its ability to modulate metabolic pathways, particularly those driven by fructose metabolism. <a href="https://liv3health.com/pages/luteolin">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapLuteolinText(this); // Recurse into children
//         }
//     });
// }
// wrapLuteolinText(document.body);
function wrapLuteolinText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bLuteolin\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Luteolin)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Luteolin is a naturally occurring flavonoid found in a variety of plant-based foods, including celery, parsley, chamomile tea, thyme, artichokes, and green peppers. As a member of the polyphenol family, luteolin has long been studied for its potent antioxidant, anti-inflammatory, and neuroprotective properties. But recent research is uncovering an even more intriguing role—its ability to modulate metabolic pathways, particularly those driven by fructose metabolism. <a href="https://liv3health.com/pages/luteolin">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    // Replace subsequent occurrences with just the plain word (no tooltip or link)
                    const newText = this.nodeValue.replace(/\b(Luteolin)\b/gi, '$1');
                    $(this).replaceWith(newText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this); // Recurse into children
            }
        });
    }

    recurse(node);
}

// Check if the current page is a luteolin page (example: URL contains 'luteolin')
if (!window.location.href.toLowerCase().includes('luteolin')) {
    wrapLuteolinText(document.body);
}

   // Metabolic Flexibility
//    function wrapMetabolicText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bMetabolic Flexibility\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Metabolic Flexibility)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Metabolic flexibility is the capacity of the body to efficiently switch between fuel sources—burning glucose when fed, and fat when fasting or exercising. <a href="https://liv3health.com/pages/metabolic-flexibility">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapMetabolicText(this); // Recurse into children
//         }
//     });
// }
// wrapMetabolicText(document.body);
function wrapMetabolicText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bMetabolic Flexibility\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Metabolic Flexibility)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Metabolic flexibility is the capacity of the body to efficiently switch between fuel sources—burning glucose when fed, and fat when fasting or exercising. <a href="https://liv3health.com/pages/metabolic-flexibility">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Metabolic Flexibility)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('metabolic-flexibility')) {
wrapMetabolicText(document.body);
}
    // Metabolic Syndrome
//    function wrapMetabolicSyndromeText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bMetabolic Syndrome\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Metabolic Syndrome)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Metabolic syndrome is a group of health issues that occur together, raising the risk of heart disease, stroke, and type 2 diabetes. It usually includes high blood sugar, high blood pressure, excess belly fat, and abnormal cholesterol levels. These problems often stem from poor metabolism and insulin resistance. Think of it as the body’s warning sign that it's struggling to manage energy and nutrients properly <a href="https://liv3health.com/pages/metabolic-syndrome">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapMetabolicSyndromeText(this); // Recurse into children
//         }
//     });
// }
// wrapMetabolicSyndromeText(document.body);
function wrapMetabolicSyndromeText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bMetabolic Syndrome\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Metabolic Syndrome)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Metabolic syndrome is a group of health issues that occur together, raising the risk of heart disease, stroke, and type 2 diabetes. It usually includes high blood sugar, high blood pressure, excess belly fat, and abnormal cholesterol levels. These problems often stem from poor metabolism and insulin resistance. Think of it as the body’s warning sign that it's struggling to manage energy and nutrients properly <a href="https://liv3health.com/pages/metabolic-syndrome">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Metabolic Syndrome)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('metabolic-syndrome')) {
wrapMetabolicSyndromeText(document.body);
}
   // Methylglyoxal
//    function wrapMethylglyoxalText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bMethylglyoxal\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Methylglyoxal)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Methylglyoxal is a reactive carbonyl compound formed as a byproduct of glycolysis and sugar metabolism—especially under conditions of fructose overload. <a href="https://liv3health.com/pages/methylglyoxal">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapMethylglyoxalText(this); // Recurse into children
//         }
//     });
// }
// wrapMethylglyoxalText(document.body);
function wrapMethylglyoxalText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bMethylglyoxal\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Methylglyoxal)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Methylglyoxal is a reactive carbonyl compound formed as a byproduct of glycolysis and sugar metabolism—especially under conditions of fructose overload. <a href="https://liv3health.com/pages/methylglyoxal">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Methylglyoxal)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('methylglyoxal')) {
wrapMethylglyoxalText(document.body);
}
   // Mitochondrial Dysfunction
//    function wrapMitochondrialText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bMitochondrial Dysfunction\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Mitochondrial Dysfunction)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Mitochondria are the power plants of cells, converting nutrients into usable energy (ATP). Mitochondrial dysfunction occurs when this process is impaired, leading to low energy, fatigue, inflammation, and cellular stress. <a href="https://liv3health.com/pages/mitochondrial-dysfunction">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapMitochondrialText(this); // Recurse into children
//         }
//     });
// }
// wrapMitochondrialText(document.body);
function wrapMitochondrialText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bMitochondrial Dysfunction\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Mitochondrial Dysfunction)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Mitochondria are the power plants of cells, converting nutrients into usable energy (ATP). Mitochondrial dysfunction occurs when this process is impaired, leading to low energy, fatigue, inflammation, and cellular stress. <a href="https://liv3health.com/pages/mitochondrial-dysfunction">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Mitochondrial Dysfunction)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('mitochondrial-dysfunction')) {
wrapMitochondrialText(document.body);
}
   // NAFLD (Fatty Liver)
//    function wrapNAFLDText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bNAFLD\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(NAFLD)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">NAFLD stands for non-alcoholic fatty liver disease, a condition where fat builds up in the liver independent of alcohol consumption. It’s one of the fastest-growing chronic diseases globally, now affecting more than 1 in 4 adults. NAFLD is strongly associated with metabolic syndrome, insulin resistance, and obesity, but it often goes undiagnosed because symptoms are subtle—if they appear at all—in the early stages. <a href="https://liv3health.com/pages/nafld-fatty-liver">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapNAFLDText(this); // Recurse into children
//         }
//     });
// }
// wrapNAFLDText(document.body);
function wrapNAFLDText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bNAFLD\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(NAFLD)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">NAFLD stands for non-alcoholic fatty liver disease, a condition where fat builds up in the liver independent of alcohol consumption. It’s one of the fastest-growing chronic diseases globally, now affecting more than 1 in 4 adults. NAFLD is strongly associated with metabolic syndrome, insulin resistance, and obesity, but it often goes undiagnosed because symptoms are subtle—if they appear at all—in the early stages. <a href="https://liv3health.com/pages/nafld-fatty-liver">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(NAFLD)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('nafld-fatty-liver')) {
wrapNAFLDText(document.body);
}
   // NASH (Non-Alcoholic Steatohepatitis)
//    function wrapNASHText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bNASH\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(NASH)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Non-Alcoholic Steatohepatitis (NASH) is a severe progression of non-alcoholic fatty liver disease (NAFLD), characterized not just by fat buildup but also by liver inflammation and cellular damage. <a href="https://liv3health.com/pages/nash-non-alcoholic-steatohepatitis">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapNASHText(this); // Recurse into children
//         }
//     });
// }
// wrapNASHText(document.body);
function wrapNASHText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bNASH\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(NASH)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Non-Alcoholic Steatohepatitis (NASH) is a severe progression of non-alcoholic fatty liver disease (NAFLD), characterized not just by fat buildup but also by liver inflammation and cellular damage. <a href="https://liv3health.com/pages/nash-non-alcoholic-steatohepatitis">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(NASH)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('nash-non-alcoholic-steatohepatitis')) {
wrapNASHText(document.body);
}
            // Sugar-Free Diet
//    function wrapSugarFreeText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bSugar-Free Diet\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Sugar-Free Diet)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">A sugar-free diet typically avoids foods and drinks that contain added sugars—like soda, candy, desserts, and many processed products. It's often recommended to support weight loss, insulin sensitivity, and metabolic health. <a href="https://liv3health.com/pages/sugar-free-diet">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapSugarFreeText(this); // Recurse into children
//         }
//     });
// }
// wrapSugarFreeText(document.body);
function wrapSugarFreeText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bSugar-Free Diet\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Sugar-Free Diet)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">A sugar-free diet typically avoids foods and drinks that contain added sugars—like soda, candy, desserts, and many processed products. It's often recommended to support weight loss, insulin sensitivity, and metabolic health. <a href="https://liv3health.com/pages/sugar-free-diet">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Sugar-Free Diet)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('sugar-free-diet')) {
wrapSugarFreeText(document.body);
}
      // Oxidative Stress
//    function wrapOxidativeText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bOxidative Stress\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Oxidative Stress)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Oxidative stress occurs when the production of reactive oxygen species (ROS) exceeds the body's ability to neutralize them with antioxidants. This imbalance damages DNA, proteins, and mitochondria. <a href="https://liv3health.com/pages/oxidative-stress">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapOxidativeText(this); // Recurse into children
//         }
//     });
// }
// wrapOxidativeText(document.body);
function wrapOxidativeText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bOxidative Stress\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Oxidative Stress)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Oxidative stress occurs when the production of reactive oxygen species (ROS) exceeds the body's ability to neutralize them with antioxidants. This imbalance damages DNA, proteins, and mitochondria. <a href="https://liv3health.com/pages/oxidative-stress">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Oxidative Stress)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('oxidative-stress')) {
wrapOxidativeText(document.body);
}
   // PCOS
//    function wrapPCOSText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bPCOS\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(PCOS)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Polycystic Ovary Syndrome (PCOS) is a hormonal condition affecting up to 1 in 10 women. It involves irregular periods, ovarian cysts, and signs of androgen excess like acne or hair growth. <a href="https://liv3health.com/pages/pcos-glossary">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapPCOSText(this); // Recurse into children
//         }
//     });
// }
// wrapPCOSText(document.body);

function wrapPCOSText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bPCOS\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(PCOS)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Polycystic Ovary Syndrome (PCOS) is a hormonal condition affecting up to 1 in 10 women. It involves irregular periods, ovarian cysts, and signs of androgen excess like acne or hair growth. <a href="https://liv3health.com/pages/pcos-glossary">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(PCOS)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('pcos-glossary')) {
wrapPCOSText(document.body);
}
    // Polyol Pathway
//    function wrapPolyolText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bPolyol Pathway\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Polyol Pathway)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">The polyol pathway is a backup process the body uses to convert glucose (sugar) into another sugar called sorbitol, and then into fructose. This usually happens when blood sugar levels are high. While it's a natural pathway, overactivation—especially during stress or excess sugar intake—can lead to cell damage and contribute to conditions like insulin resistance and inflammation. Think of it as a sugar detour that can cause trouble when overused <a href="https://liv3health.com/pages/polyol-pathway">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapPolyolText(this); // Recurse into children
//         }
//     });
// }
// wrapPolyolText(document.body);
function wrapPolyolText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bPolyol Pathway\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Polyol Pathway)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">The polyol pathway is a backup process the body uses to convert glucose (sugar) into another sugar called sorbitol, and then into fructose. This usually happens when blood sugar levels are high. While it's a natural pathway, overactivation—especially during stress or excess sugar intake—can lead to cell damage and contribute to conditions like insulin resistance and inflammation. Think of it as a sugar detour that can cause trouble when overused <a href="https://liv3health.com/pages/polyol-pathway">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Polyol Pathway)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('polyol-pathway')) {
wrapPolyolText(document.body);
}

    // Tart Cherry Extract
//    function wrapTartCherryText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bTart Cherry Extract\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Tart Cherry Extract)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Tart cherry extract is derived from Montmorency cherries and is rich in anthocyanins—natural antioxidants with powerful anti-inflammatory properties. <a href="https://liv3health.com/pages/tart-cherry-extract">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapTartCherryText(this); // Recurse into children
//         }
//     });
// }
// wrapTartCherryText(document.body);
function wrapTartCherryText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bTart Cherry Extract\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Tart Cherry Extract)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Tart cherry extract is derived from Montmorency cherries and is rich in anthocyanins—natural antioxidants with powerful anti-inflammatory properties. <a href="https://liv3health.com/pages/tart-cherry-extract">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Tart Cherry Extract)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('tart-cherry-extract')) {
wrapTartCherryText(document.body);
}
    // Triglycerides
//    function wrapTriglyceridesText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bTriglycerides\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Triglycerides)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Triglycerides are a type of fat (lipid) found in the blood. After eating, the body converts excess calories—especially from sugar and carbs—into triglycerides for storage. <a href="https://liv3health.com/pages/triglycerides">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapTriglyceridesText(this); // Recurse into children
//         }
//     });
// }
// wrapTriglyceridesText(document.body);
function wrapTriglyceridesText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bTriglycerides\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Triglycerides)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Triglycerides are a type of fat (lipid) found in the blood. After eating, the body converts excess calories—especially from sugar and carbs—into triglycerides for storage. <a href="https://liv3health.com/pages/triglycerides">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Triglycerides)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('triglycerides')) {
wrapTriglyceridesText(document.body);
}
    // Uric Acid
//    function wrapUricAcidText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bUric Acid\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Uric Acid)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Uric acid is a natural waste product that forms when the body breaks down substances called purines, which are found in certain foods like red meat, seafood, and alcohol. However, one of the lesser-known but more potent triggers of elevated uric acid levels is fructose metabolism—a key reason this simple sugar is increasingly implicated in metabolic diseases. <a href="https://liv3health.com/pages/uric-acid">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapUricAcidText(this); // Recurse into children
//         }
//     });
// }
// wrapUricAcidText(document.body);
function wrapUricAcidText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bUric Acid\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Uric Acid)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Uric acid is a natural waste product that forms when the body breaks down substances called purines, which are found in certain foods like red meat, seafood, and alcohol. However, one of the lesser-known but more potent triggers of elevated uric acid levels is fructose metabolism—a key reason this simple sugar is increasingly implicated in metabolic diseases. <a href="https://liv3health.com/pages/uric-acid">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Uric Acid)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('uric-acid')) {
wrapUricAcidText(document.body);
}
    // Visceral Fat
//    function wrapUricAcidText(node) {
//     $(node).contents().each(function () {
//         if (this.nodeType === 3 && /\bVisceral Fat\b/i.test(this.nodeValue)) {
//             const newHtml = this.nodeValue.replace(
//                 /\b(Visceral Fat)\b/gi,
//                 `<span class="highlighthov">$1 <div class="hovertext">Visceral fat is the fat stored deep inside the abdomen, wrapped around internal organs like the liver, pancreas, and intestines. It's different from subcutaneous fat, which lies under the skin. <a href="https://liv3health.com/pages/visceral-fat">Read More</a></div></span>`
//             );
//             $(this).replaceWith(newHtml);
//         } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
//             wrapUricAcidText(this); // Recurse into children
//         }
//     });
// }
// wrapUricAcidText(document.body);
function wrapVisceralFatText(node) {
    let tooltipCount = 0;
    const maxTooltips = 1;
    // Helper to check if node is inside a heading tag
    function isInsideHeading(node) {
        return !window.LIV3Glossary.canDecorate(node);
    }
    function recurse(currentNode) {
        $(currentNode).contents().each(function () {
            if (this.nodeType === 3 && /\bVisceral Fat\b/i.test(this.nodeValue)) {
                if (tooltipCount < maxTooltips && !isInsideHeading(this)) {
                    const newHtml = this.nodeValue.replace(
                        /\b(Visceral Fat)\b/gi,
                        `<span class="highlighthov">$1 <div class="hovertext">Visceral fat is the fat stored deep inside the abdomen, wrapped around internal organs like the liver, pancreas, and intestines. It's different from subcutaneous fat, which lies under the skin. <a href="https://liv3health.com/pages/visceral-fat">Read More</a></div></span>`
                    );
                    $(this).replaceWith(newHtml);
                    tooltipCount++;
                } else {
                    const plainText = this.nodeValue.replace(/\b(Visceral Fat)\b/gi, '$1');
                    $(this).replaceWith(plainText);
                }
            } else if (this.nodeType === 1 && !/(script|style)/i.test(this.tagName)) {
                recurse(this);
            }
        });
    }

    recurse(node);
}
if (!window.location.href.toLowerCase().includes('visceral-fat')) {
wrapVisceralFatText(document.body);
}

   // Accessible, viewport-aware glossary popovers. The hidden definition stays
   // beside its term for graceful fallback; the visible card is rendered once
   // at the document root so containers cannot crop it.
   function initGlossaryPopovers() {
      const excludedTriggerSelector = 'a, button, nav, header, footer, aside, h1, h2, h3, h4, h5, h6, figcaption, cite, sup, .guidleft, .hovertext, [data-glossary-ignore]';
      const triggers = Array.from(document.querySelectorAll('main .highlighthov')).filter(function (trigger) {
         return !trigger.parentElement.closest(excludedTriggerSelector) &&
            !!trigger.querySelector(':scope > .hovertext');
      });

      if (!triggers.length) {
         return;
      }

      const popover = document.createElement('div');
      popover.id = 'liv3-glossary-popover';
      popover.className = 'glossary-popover';
      popover.setAttribute('role', 'dialog');
      popover.setAttribute('aria-modal', 'false');
      popover.setAttribute('aria-hidden', 'true');
      popover.innerHTML = '<div class="glossary-popover__term"></div><div class="glossary-popover__definition"></div><span class="glossary-popover__arrow" data-popper-arrow></span>';
      document.body.appendChild(popover);

      const popoverTerm = popover.querySelector('.glossary-popover__term');
      const popoverDefinition = popover.querySelector('.glossary-popover__definition');
      let activeTrigger = null;
      let popperInstance = null;
      let closeTimer = null;
      let pinnedOpen = false;
      let suppressFocusOpen = false;

      function clearCloseTimer() {
         if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
         }
      }

      function getTermText(trigger) {
         const copy = trigger.cloneNode(true);
         copy.querySelectorAll('.hovertext').forEach(function (definition) {
            definition.remove();
         });
         return copy.textContent.replace(/\s+/g, ' ').trim();
      }

      function fitPopoverToViewport() {
         popover.classList.remove('glossary-popover--scrollable');
         popoverDefinition.style.maxHeight = '';

         const viewportGutter = 16;
         const maximumPopoverHeight = Math.max(180, window.innerHeight - (viewportGutter * 2));
         const naturalPopoverHeight = popover.getBoundingClientRect().height;

         if (naturalPopoverHeight > maximumPopoverHeight) {
            const definitionHeight = popoverDefinition.getBoundingClientRect().height;
            const nonDefinitionHeight = naturalPopoverHeight - definitionHeight;
            const availableDefinitionHeight = Math.max(120, maximumPopoverHeight - nonDefinitionHeight);

            popoverDefinition.style.maxHeight = availableDefinitionHeight + 'px';
            popover.classList.add('glossary-popover--scrollable');
         }
      }

      function fallbackPosition(trigger) {
         const gutter = 16;
         const offset = 12;
         const triggerRect = trigger.getBoundingClientRect();
         const popoverRect = popover.getBoundingClientRect();
         let top = triggerRect.top - popoverRect.height - offset;
         let left = triggerRect.left + ((triggerRect.width - popoverRect.width) / 2);

         if (top < gutter) {
            top = triggerRect.bottom + offset;
         }

         left = Math.max(gutter, Math.min(left, window.innerWidth - popoverRect.width - gutter));
         popover.style.top = Math.max(gutter, top) + 'px';
         popover.style.left = left + 'px';
      }

      function openPopover(trigger, pin, focusLink) {
         clearCloseTimer();
         pinnedOpen = !!pin;

         if (activeTrigger && activeTrigger !== trigger) {
            activeTrigger.setAttribute('aria-expanded', 'false');
         }

         activeTrigger = trigger;
         const source = trigger.querySelector(':scope > .hovertext');
         const termText = getTermText(trigger);

         popoverTerm.textContent = termText;
         popoverDefinition.innerHTML = source.innerHTML;
         popoverDefinition.querySelectorAll('.highlighthov').forEach(function (nestedTerm) {
            nestedTerm.replaceWith(document.createTextNode(getTermText(nestedTerm)));
         });

         const readMoreLink = popoverDefinition.querySelector('a');
         if (readMoreLink && readMoreLink.textContent.trim().toLowerCase() === 'read more') {
            readMoreLink.textContent = 'Read full definition →';
         }

         trigger.setAttribute('aria-expanded', 'true');
         popover.setAttribute('aria-label', 'Glossary definition: ' + termText);
         popover.setAttribute('aria-hidden', 'false');
         popover.setAttribute('data-show', '');
         fitPopoverToViewport();

         if (popperInstance) {
            popperInstance.destroy();
            popperInstance = null;
         }

         if (window.Popper && typeof window.Popper.createPopper === 'function') {
            popperInstance = window.Popper.createPopper(trigger, popover, {
               placement: 'top',
               strategy: 'fixed',
               modifiers: [
                  { name: 'offset', options: { offset: [0, 12] } },
                  { name: 'flip', options: { fallbackPlacements: ['bottom', 'right', 'left'] } },
                  { name: 'preventOverflow', options: { boundary: 'viewport', padding: 16 } },
                  { name: 'arrow', options: { element: popover.querySelector('[data-popper-arrow]'), padding: 12 } }
               ]
            });
         } else {
            window.requestAnimationFrame(function () {
               fallbackPosition(trigger);
            });
         }

         if (focusLink && readMoreLink) {
            window.requestAnimationFrame(function () {
               readMoreLink.focus();
            });
         }
      }

      function closePopover(returnFocus) {
         clearCloseTimer();
         const triggerToRestore = activeTrigger;

         if (triggerToRestore) {
            triggerToRestore.setAttribute('aria-expanded', 'false');
         }

         activeTrigger = null;
         pinnedOpen = false;
         popover.removeAttribute('data-show');
         popover.setAttribute('aria-hidden', 'true');

         if (popperInstance) {
            popperInstance.destroy();
            popperInstance = null;
         }

         if (returnFocus && triggerToRestore) {
            suppressFocusOpen = true;
            triggerToRestore.focus();
            window.requestAnimationFrame(function () {
               suppressFocusOpen = false;
            });
         }
      }

      function scheduleClose() {
         clearCloseTimer();
         closeTimer = window.setTimeout(function () {
            if (!pinnedOpen && !popover.matches(':hover')) {
               closePopover(false);
            }
         }, 140);
      }

      triggers.forEach(function (trigger) {
         const source = trigger.querySelector(':scope > .hovertext');
         source.setAttribute('aria-hidden', 'true');
         trigger.setAttribute('role', 'button');
         trigger.setAttribute('tabindex', '0');
         trigger.setAttribute('aria-haspopup', 'dialog');
         trigger.setAttribute('aria-controls', popover.id);
         trigger.setAttribute('aria-expanded', 'false');

         trigger.addEventListener('mouseenter', function () {
            if (!pinnedOpen || activeTrigger !== trigger) {
               openPopover(trigger, false, false);
            }
         });
         trigger.addEventListener('mouseleave', scheduleClose);
         trigger.addEventListener('focus', function () {
            if (!suppressFocusOpen) {
               openPopover(trigger, false, false);
            }
         });
         trigger.addEventListener('blur', scheduleClose);
         trigger.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (activeTrigger === trigger && pinnedOpen) {
               closePopover(false);
            } else {
               openPopover(trigger, true, false);
            }
         });
         trigger.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
               event.preventDefault();
               openPopover(trigger, true, true);
            } else if (event.key === 'Escape') {
               event.preventDefault();
               closePopover(true);
            }
         });
      });

      popover.addEventListener('mouseenter', clearCloseTimer);
      popover.addEventListener('mouseleave', scheduleClose);
      popover.addEventListener('focusin', clearCloseTimer);
      popover.addEventListener('focusout', function () {
         window.setTimeout(function () {
            if (!popover.contains(document.activeElement) && document.activeElement !== activeTrigger) {
               closePopover(false);
            }
         }, 0);
      });

      document.addEventListener('pointerdown', function (event) {
         if (activeTrigger && !activeTrigger.contains(event.target) && !popover.contains(event.target)) {
            closePopover(false);
         }
      });
      document.addEventListener('keydown', function (event) {
         if (event.key === 'Escape' && activeTrigger) {
            event.preventDefault();
            closePopover(true);
         }
      });
      window.addEventListener('resize', function () {
         if (activeTrigger) {
            fitPopoverToViewport();
            if (popperInstance) {
               popperInstance.update();
            }
         }
      });
   }

   initGlossaryPopovers();

   // slider
   jQuery('.testislider').slick({
     infinite: true,slidesToShow: 1,slidesToScroll: 1,autoplay: true,autoplaySpeed: 2000,dots:true,
   responsive: [
    {
      breakpoint: 601,
      settings: {
        arrows:false
      }
    }
  ]});
   jQuery(window).scroll(function() {
        var scrollPosition = jQuery(this).scrollTop();
        var targetDiv = jQuery('.innerdetailmain');

        // Change the scroll position threshold as needed
        if (scrollPosition > 100) { // Example threshold
            targetDiv.addClass('active');
        } else {
            targetDiv.removeClass('active');
        }
    });
   sidecart();
    function sidecart(){
      jQuery.get("/cart?view=sidecart", function(e) {
        jQuery('#sidecart').html(e);
      });
      jQuery.getJSON("/cart.json", function(e) {
		// var total_cart_price = Shopify.formatMoney(e.original_total_price);
		jQuery(".open_cart h5").text(e.item_count); });
    }
    $.getJSON("/cart.json", function(e) {
		var total_cart_price = Shopify.formatMoney(e.original_total_price);
		$("[data-cartitmes]").text(e.item_count);
        // $('#cart_total, #cartotal').html(total_cart_price);
        // for (let i = 0; i < e.items.length; i++) {
        //   jQuery('#btn-func-'+e.items[i].id).addClass('active');
        //   jQuery('#btn-func-'+e.items[i].id).find('input').val(e.items[i].quantity);
        // }
      });
      $.get('/cart?view=drawer', function (cartitems) {
        $('#cartdrawer').html(cartitems);
      });
      
      $.get('/cart', function (data) {
        var content = $(data).find('.cartitems').html();
        $('#cart_list').html(content);
      });
   jQuery('ul.nav_menu li.has_sub_menu.mega_menu ul.sub_menu > li').each( function(){
		jQuery(this).append('<span class="sub_menu_icon"></span>');
	});
   jQuery(document.body).on('click', '.quantity .plus', function (e) {
        var t = jQuery(this);
      	var ID = t.data('id');
        $input = t.prev('input.qty');
        var plusqty = parseInt($input.val());
        $input.val(plusqty+1)
//         data = {
//         "id": ID,
//         "quantity": plusqty
//         }
//         console.log(data);
});

jQuery(document.body).on('click', '.quantity .minus',function (e) {
    var t = jQuery(this);
    var ID = t.data('id');
    $input = t.next('input.qty');
    var minqty = parseInt($input.val());
    
  if($input.val()>0){}
  else{
    $input.val(minqty-1);
  }
  });
  $(document.body).on('click', '[data-minusqttpx]', function(e){
        e.preventDefault();
        var t = $(this);
        let qty = t.siblings('input[type="number"]');
        let minus = parseInt(qty.val())-1;
        let productId = t.data('id');
        if( minus > 0 ){
          qty.val(minus);
          $.ajax({
              type: "post",
              url: "/cart/change.js",
              data: 'quantity='+minus+'&id=' + productId,
              dataType: 'json',
              success: function(cart) {
                 vis.getItems(); 
              },
              error: function(xhr) {}
          });
        }
      });
  $(document.body).on('click', '[data-plusqttpx]', function(e){
        e.preventDefault();
        var t = $(this),
         qty = t.siblings('input[type="number"]'),
         max_q = qty.data('max'),
         form_id = qty.data('form-id'),
         productId = t.data('id'),
         q = parseInt(qty.val())+1;
        if( q < max_q || q == max_q ){
          qty.val(q);
            $.ajax({
                type: "post",
                url: "/cart/change.js",
                data: 'quantity='+q+'&id=' + productId,
                dataType: 'json',
                success: function(cart) {
                   vis.getItems(); 
                },
                error: function(xhr) {}
            });
        }
        if( q > max_q ){
        	$('[data-lmtqty="'+productId+'"]').html('<div class="limited_qty"><i class="fa fa-info-circle"></i> Maximum quantity '+ max_q+'</div>');
          setTimeout(function(){ $('[data-lmtqty="'+productId+'"]').html('') }, 1500 );
        }
      });
   $(document.body).on('click','#remove-item', function(){
        var t = $(this);
        var id = t.data('id');
        $.ajax({
            type: "post",
            url: "/cart/change.js",
            data: 'quantity=0&id=' + id,
            dataType: 'json',
            success: function(cart) {
              vis.getItems(); 
               cart_sidebar_update();
               $('#cartdt_'+id+', [data-id="'+id+'"]').remove();
            },
            error: function(xhr) {          
                 
            }
        });
      });
  cart_sidebar_update();
  function cart_sidebar_update(){
      jQuery.getJSON('/cart.js', function(cart){
        if (cart.item_count == 0) {
          jQuery('.cart-sidebar').addClass("is_empty");
          $('.no-item-cart').show();
        }      
    });
  };
   jQuery(".recover-password").click(function() {
    jQuery(".login-form").hide();
    jQuery(".forgot-form").show();
  });
  
  jQuery(".back-login").click(function() {
    jQuery(".login-form").show();
    jQuery(".forgot-form").hide();
  });
   jQuery('.getfree').slick({infinite: true,slidesToShow: 1,slidesToScroll: 1,autoplay: true,autoplaySpeed: 2000,speed:1000,
     responsive: [
    {
      breakpoint: 961,
      settings: {
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 601,
      settings: {
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    }
  ]});
   var body = $('body'),
        doc = $(document),
        html = $('html'),
        win = $(window);
   var wishListsArr = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];
    var compareArr = localStorage.getItem('compareArr') ? JSON.parse(localStorage.getItem('compareArr')) : [];

    localStorage.setItem('items', JSON.stringify(wishListsArr));
    if (wishListsArr.length) {
        wishListsArr = JSON.parse(localStorage.getItem('items'));
    };
   var sidebar = document.getElementById('offcanvasRight');
    var sidecart = new bootstrap.Offcanvas(sidebar);
  var vis = {
    init: function(){
      this.main_menu_fixed();
      this.mobile_menu();
      this.mobile_tabs();
      this.getItems();
      this.wishlist();
      this.wishlisticons();
      this.ajax_pagination();
      this.set_page_items();
      this.removeitems();
    },
    main_menu_fixed: function(){
       $(window).scroll(function() {
    		scroll = $(window).scrollTop();
    		var e = $(".site-header");
    		scroll >= 210 ? e.addClass("fixed") : e.removeClass("fixed");
    	});
    },
    mobile_menu: function(){
      $('li.submenu a.alink').on('click', function(e){
        e.preventDefault();
        var t = $(this); t.parent().toggleClass('open_dropdown'); t.parent().find('ul').slideToggle();
        t.parent().siblings().removeClass('open_dropdown');t.parent().siblings().find('ul').slideUp();
      });
      $('.site_footer .ft-widget h3.toggle_menu').on('click', function(){
        var t = $(this); t.parent().toggleClass('active'); t.next().slideToggle();
      });
    },
    mobile_tabs: function(){
      $('a[href="#pxaccount"]').on('click', function(e){
        e.preventDefault();
    		$('[data-user-mobile-toggle]').trigger('click');
      });
      $('a[href="#home"]').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
          scrollTop: jQuery("#shopify-section-header").offset().top
        }, 1000); 
         $('.vis_search_bar input[type="search"]').focus();
      });
      $('a[href="#search"]').on('click', function(e){
        e.preventDefault();
      	$('.vis_search_bar').slideToggle();
         $('.vis_search_bar input[type="search"]').focus();
      });
    },
    getItems: function(){
      $.getJSON("/cart.json", function(e) {
		var total_cart_price = Shopify.formatMoney(e.original_total_price);
		$("[data-cartcount],a.menu-cart-icon span,a#open_cart h5").text(e.item_count);
        if( e.item_count == 0 ){
          $('.no-item-cart').show();
          $('form.cart-form.wrapper-template-cart').hide();
        }else{
          $('.no-item-cart').hide();
          $('form.cart-form.wrapper-template-cart').show();
        }
        if( e.item_count > 1 ){
          $('[data-cartabre]').text('are');
        }else{
          $('[data-cartabre]').text('is');
        }
        $("#offcanvasRight .total span.price,.cart_sumary .total span.price").html(Shopify.formatMoney(e.original_total_price));
        if( e.items.length == 0 ){
          $('.no-items').show();
        }else{
          $('.no-items').hide();
        }
        $('[data-toggle="tooltip"]').tooltip();
        if(e.item_count == 0){
          $('.offcanmy .offcanvas-body').addClass('offcanvas-bodyy');
          $('.showifcartdata').hide();
          $('.ifhasnot').show();
          $('.minicart').hide();
        }else{
          $('.offcanmy .offcanvas-body').removeClass('offcanvas-bodyy');
          $('.showifcartdata').show();
          $('.ifhasnot').hide();
          $('.minicart').show();
        }
      });
      jQuery.get("/cart?view=sidecart", function(e) {
        jQuery('#sidecart').html(e);
      });
      jQuery.getJSON("/cart.json", function(e) {
		//var total_cart_price = Shopify.formatMoney(e.total_price);
		jQuery(".open_cart h5").text(e.item_count);
        jQuery(".right-sumy .cart-price, .right-sumy .clr-pri, .sidccarttotal .price").text(Shopify.formatMoney(e.total_price));
        for (let i = 0; i < e.items.length; i++) {
            $('[data-prodid="' + e.items[i].id + '"]').text(Shopify.formatMoney(e.items[i].line_price));
          $('[data-prodid="' + e.items[i].id + '"]').text(Shopify.formatMoney(e.items[i].line_price));
		}
      });
      var sortby = $('a.dropdown-item.cactive').text();
      $('#tabletxt').text(sortby);
    },
    wishlist:function(ProductHandle){
      var wishlistElm = $('[data-product-handle="'+ ProductHandle +'"]'),
            idxArr = wishListsArr.indexOf(ProductHandle);
        $('#WishCounter').text(wishListsArr.length);
        if(idxArr >= 0) {
            wishlistElm.addClass('whislist-added');
                wishlistElm.find('.wishlist-text').text('window.inventory_text.remove_wishlist'); 
        }
        else {
            wishlistElm.removeClass('whislist-added');
                wishlistElm.find('.wishlist-text').text('window.inventory_text.add_wishlist');
        };
      var iconWishListsSlt = '[data-icon-wishlist]';

            doc.off('click.addOrRemoveWishlist', iconWishListsSlt).on('click.addOrRemoveWishlist', iconWishListsSlt, function(e) {
                e.preventDefault();

                var self = $(this),
                    productId = self.data('id'),
                    ProductHandle = self.data('product-handle'),
                    idxArr = wishListsArr.indexOf(ProductHandle);

                if(!self.hasClass('whislist-added')) {
                    self.addClass('whislist-added');
                        self.find('.wishlist-text').text('window.inventory_text.remove_wishlist');

                    if($('[data-wishlist-container]').length) {
                        ella.createWishListTplItem(ProductHandle);
                    };

                    wishListsArr.push(ProductHandle);
                    localStorage.setItem('items', JSON.stringify(wishListsArr));
                } else {
                    self.removeClass('whislist-added');
                    $('[data-wishlist-added="wishlist-'+productId+'"]').remove();

                    wishListsArr.splice(idxArr, 1);
                    localStorage.setItem('items', JSON.stringify(wishListsArr));

                    if($('[data-wishlist-container]').length) {
                      
                    };
                };

                vis.wishlist(ProductHandle);
            });
    },
    wishlisticons: function() {
        var wishListItems = JSON.parse(localStorage.getItem('items'));
      // var listitem = wishListItems.split(",");
        for (var i = 0; i < wishListItems.length; i++) {
            var icon = $('[data-product-handle="'+ wishListItems[i] +'"]');
            icon.addClass('whislist-added');
          $.get('/products/' + wishListItems[i] + '?view=wishlist', function (quick_response) {
            $('#vis_wishlist').append(quick_response);
          }); 
        }
    },
    ajax_pagination: function(){ var count = 1;
      $(document.body).on('click', '.px-infinite-scrolling a', function(e){
        count++; e.preventDefault();
        $(this).append(' <div class="spinner-border spinner-border-sm"></div>');
        $.ajax({
            type: "get",
            url: $(this).data('href'),
            beforeSend: function () {
            },
            success: function (data) {
              var result = $(data).find('.product-collection.fav_products ul, .blog_list ul').html();
              var filterform = $(data).find('.filter-form').html();
              var pagebtn = $(data).find('.px-infinite-scrolling').html();
              $('.px-infinite-scrolling').html(pagebtn);
              $('.product-collection.fav_products ul, .blog_list ul').append(result);
              $('#filter-form').html(filterform); 
              $(".js-range-slider").ionRangeSlider({
                 onChange: function(rp){
                   $('input[name="filter.v.price.gte"]').val(rp.from);
                       $('input[name="filter.v.price.lte"]').val(rp.to);
                 },
                onFinish: function(){
                  $('#filter-form').append('<input type="hidden" name="sort_by" value="price-ascending" />');
                  $('#filter-form').submit();
                }
              });
              $('.loading-modal').hide();
              $("div.col-sidebar .filter-group ul li").slice(0, 10).show();
              $("div.col-sidebar .filter-groups ul li").slice(0, 10).show();
              $("ul#filtter-health-ingredients li").slice(0, 10).show();
              $("ul#filtter-brand li").slice(0, 10).show();
            }, 
            error: function (xhr, text) {},
            complete: function () {
              var st = $('#filter-form'),
               sf = st.serialize(); 
              window.history.pushState('page2', 'Title', '?'+sf);
            }
        });
      });
    },
    set_page_items: function(){
      $(document.body).on('click', '[data-setitemnumber] a',function(e){
       e.preventDefault();  
        var v = $(this).data('pnumber');
        $.ajax({
            type: "Post",
            url: '/cart.js',
            data: {
                "attributes[pagination]": v
            },
            success: function (data) {
                window.location.reload();
            },
            error: function (xhr, text) {
 
            },
            dataType: 'json'
        });
     });
      
    },
    removeitems: function(){
      $(document.body).on('click','#remove-item', function(){
        var t = $(this);
        var id = t.data('id');
        $.ajax({
            type: "post",
            url: "/cart/change.js",
            data: 'quantity=0&id=' + id,
            dataType: 'json',
            success: function(cart) {
              jQuery('[data-product-id="'+id+'"],[data-item-id="'+id+'"]').remove();
              vis.getItems(); 
              
            },
            error: function(xhr) {          
                 
            }
        });
      });
    },
  }; 
  vis.init();
    var w = window.innerWidth;
     
   $(document.body).on('submit', '#add-to_cart,[data-type="add-to-cart-form"]',function (e) {
     e.preventDefault();
      var t = $(this);
     var data = t.serialize();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
           vis.getItems();
          sidecart.show();
        }
      });
    });
   $(document.body).on('click', '#vis_addcart',function (e) {
      var id = $(this).attr('data-id'); e.preventDefault();
     
      datass = {
        "id": id,
        "quantity": 1
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: datass,
        dataType: 'json',
        success: function (cart) {
          vis.getItems();
        }
      });
    });
    
  $(document.body).on('click', '[data-plus]', function(e){
        e.preventDefault();
        var t = $(this),
         qty = t.siblings('input[type="number"]'),
         max_q = qty.data('max'),
         productId = qty.data('id'),
         q = parseInt(qty.val())+1;
        if( q < max_q || q == max_q ){
          qty.val(q);
            $.ajax({
                type: "post",
                url: "/cart/change.js",
                data: 'quantity='+q+'&id=' + productId,
                dataType: 'json',
                success: function(cart) {
                   vis.getItems();
                },
                error: function(xhr) {}
            });
        }
        if( q > max_q ){
        	$('[data-lmtqty="'+productId+'"]').html('<div class="limited_qty"><i class="fa fa-info-circle"></i> Maximum quantity '+ max_q+'</div>');
          setTimeout(function(){ $('[data-lmtqty="'+productId+'"]').html('') }, 1500 );
        }
      });
    $(document.body).on('click', '[data-minus]', function(e){
      e.preventDefault();
      var t = $(this);
      let qty = t.siblings('input[type="number"]');
      let minus = parseInt(qty.val())-1;
      let productId = qty.data('id');
      if( minus > 0 ){
        qty.val(minus);
        $.ajax({
            type: "post",
            url: "/cart/change.js",
            data: 'quantity='+minus+'&id=' + productId,
            dataType: 'json',
            success: function(cart) {
               vis.getItems();
            },
            error: function(xhr) {}
        });
      }
    });
});
